import { Component, OnInit, inject } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { OverviewState, Tabs } from './models/overview.model';
import * as OverviewActions from './store/actions/overview.actions';
import { selectCurrentTab } from './store/selectors/overview.selector';

@Component({
  selector: 'app-overview-table',
  templateUrl: './overview.component.html',
  standalone: false,
})
export class OverviewComponent implements OnInit {
  private readonly store = inject<Store<OverviewState>>(Store);

  tabs = Tabs;
  currentTab$: Observable<Tabs>;

  constructor() {
    this.currentTab$ = this.store.pipe(select(selectCurrentTab));
  }
  ngOnInit(): void {
    this.store.dispatch(OverviewActions.switchToManureOffersOverview());
  }
}
